import { useMemo } from 'react';

import { useRewardPoolsFeaturedAndDailyInfiniteQuery } from '@shared/hooks/query/rewardPools';

import RewardPoolsSlider from '../common/RewardPoolsSlider';
import { SegmentContainer } from './SegmentContainer';

export const FeaturedAndDailyPools = () => {
  const { data: featuredRewardPools } = useRewardPoolsFeaturedAndDailyInfiniteQuery();

  const allRewardPools = useMemo(
    () => featuredRewardPools?.pages.flatMap((page) => page.pools) || [],
    [featuredRewardPools],
  );

  if (!allRewardPools.length) {
    return null;
  }

  return (
    <SegmentContainer title="Featured & Daily Pools">
      <RewardPoolsSlider rewardPools={allRewardPools} />
    </SegmentContainer>
  );
};
